// extracted by mini-css-extract-plugin
export default {"postCaptureButtonContainer":"post-capture-button-container__post-capture-button-container___02Y7","postCaptureButton":"post-capture-button-container__post-capture-button__xvPIV"};